export const SiteHeader: React.FC = () => {
  return (
    <header className="site-header sticky top-0 z-40 backdrop-blur bg-white/80 border-b shadow-sm">
      <div className="container mx-auto flex items-center justify-between py-3 px-4">
        <div className="flex items-center gap-2">
          <img
            src="/ageiro-logo.svg"
            alt="Ageiro"
            className="h-20 w-auto"
          />
        </div>

        <nav className="hidden md:flex items-center gap-6 text-sm font-medium">
          <a href="#overview" className="text-slate-700 hover:text-slate-900 transition-colors">Overview</a>
          <a href="#capabilities" className="text-slate-700 hover:text-slate-900 transition-colors">Capabilities</a>
          <a href="#use-cases" className="text-slate-700 hover:text-slate-900 transition-colors">Use Cases</a>
          <a href="#security" className="text-slate-700 hover:text-slate-900 transition-colors">Security</a>
          <a href="#connectors" className="text-slate-700 hover:text-slate-900 transition-colors">Connectors</a>
          <a href="#contact" className="text-slate-700 hover:text-slate-900 transition-colors">Contact</a>
        </nav>

        <div className="flex items-center gap-2">
          <a href="https://www.ageiro.global/contact-sales" className="primary-cta px-4 py-2 rounded-lg text-sm font-semibold shadow-sm">
            Request a Demo
          </a>
        </div>
      </div>
    </header>
  );
};
